import Page from './components/page.vue'


export default {
  path: '/recover',
  component: Page
}



// WEBPACK FOOTER //
// ./src/recover/routes.js